export const SessionStorageEnum = {
    SESSION_ID: "sessionId",
    SHOW_CALAMITY_HEADER: "showCalamityHeader"
}